import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';

export enum LicenseItemDisableReason {
  FOR_FUTURE_USE = 'ForFutureUse',
  WORKFLOW_ENTERPRISE_FEATURE_IS_USED = 'WorkflowEnterpriseFeatureIsUsed',
  WORKFLOW_CONTACT_CENTER_FEATURE_IS_USED = 'WorkflowContactCenterFeatureIsUsed',
  AFTER_CALL_WORK_IS_ENABLED = 'AfterCallWorkIsEnabled',
  CONVERSATION_CONTEXT_IS_ENABLED = 'ConversationContextIsEnabled',
  INSTANT_MESSAGING_WORKFLOW_ENABLED = 'InstantMessagingWorkflowEnabled',
  OUTBOUND_CALL_WITH_WORKFLOW_ENABLED = 'OutboundCallWithWorkflowEnabled',
  SKILL_BASED_USER_ASSIGNMENT_TYPE_IS_USED = 'SkillBasedUserAssignmentTypeIsUsed',
  STORE_CONVERSATION_CONTEXT_DATA_IS_ENABLED = 'StoreConversationContextDataIsEnabled',
  SYSTEM_AND_CUSTOM_PARAMETER_IN_WIDGET_IS_USED = 'SystemAndCustomParametersInWidgetIsUsed',
  EMAIL_WORKFLOW_ENABLED = 'EmailWorkflowEnabled',
  EXTERNAL_TASKS_WORKFLOW_ENABLED = 'ExternalTasksWorkflowEnabled',
  INTERACT_FOR_SERVICE_IS_USED = 'InteractForServiceIsUsed',
  PREVENT_LICENSE_BREACH = 'PreventLicenseBreach',
  NIMBUS_UNIFY_SERVICE_LICENSE_DISABLED_REASON = 'NimbusUnifyServiceLicenseDisabledReason',
  COMPANION_ON_TENANT_IS_DISABLED = 'CompanionOnTenantIsDisabled',
  DIRECT_CALL_RESOURCE_ACCOUNT_ASSIGNED = 'DirectCallResourceAccountAssigned',
}

export enum LicenseAddonItemDisableReason {
  INTERACT_FOR_SERVICE_IS_USED = 'InteractForServiceIsUsed',
  ENTERPRISE_OR_CONTACT_CENTER_REQUIRED = 'EnterpriseOrContactCenterRequired',
  INTERACT_ON_TENANT_IS_DISABLED = 'InteractOnTenantIsDisabled',
  PREVENT_LICENSE_BREACH = 'PreventLicenseBreach',
}

export enum UserLicenseDisabledReasonType {
  PREVENT_LICENSE_BREACH = 'PreventLicenseBreach',
  VIRTUAL_USER_ON_TENANT_IS_DISABLED = 'VirtualUserOnTenantIsDisabled',
}

export const LicenseItemDisableReasonTranslationMapper: Record<LicenseItemDisableReason, TranslationKeys> = {
  [LicenseItemDisableReason.AFTER_CALL_WORK_IS_ENABLED]: TranslationKeys.SettingsFormDisabledReasonAfterCallWorkIsEnabled,
  [LicenseItemDisableReason.WORKFLOW_ENTERPRISE_FEATURE_IS_USED]: TranslationKeys.SettingsFormDisabledReasonAVWorkflowIsUsed,
  [LicenseItemDisableReason.WORKFLOW_CONTACT_CENTER_FEATURE_IS_USED]: TranslationKeys.SettingsFormDisabledReasonAVWorkflowIsUsed,
  [LicenseItemDisableReason.CONVERSATION_CONTEXT_IS_ENABLED]: TranslationKeys.SettingsFormDisabledReasonConversationContextIsEnabled,
  [LicenseItemDisableReason.INSTANT_MESSAGING_WORKFLOW_ENABLED]: TranslationKeys.SettingsFormDisabledReasonIMWorkflowEnabled,
  [LicenseItemDisableReason.OUTBOUND_CALL_WITH_WORKFLOW_ENABLED]: TranslationKeys.SettingsFormDisabledReasonOutboundCallWithWorkflowEnabled,
  [LicenseItemDisableReason.FOR_FUTURE_USE]: TranslationKeys.SettingsFormDisabledReasonForFutureUse,
  [LicenseItemDisableReason.SKILL_BASED_USER_ASSIGNMENT_TYPE_IS_USED]:
    TranslationKeys.SettingsFormDisabledReasonSkillBasedUserAssignmentTypeIsUsed,
  [LicenseItemDisableReason.STORE_CONVERSATION_CONTEXT_DATA_IS_ENABLED]:
    TranslationKeys.SettingsFormDisabledReasonStoreConversationContextDataIsEnabled,
  [LicenseItemDisableReason.SYSTEM_AND_CUSTOM_PARAMETER_IN_WIDGET_IS_USED]:
    TranslationKeys.SettingsFormDisabledReasonSystemAndCustomParametersInWidgetIsUsed,
  [LicenseItemDisableReason.EMAIL_WORKFLOW_ENABLED]: TranslationKeys.SettingsFormDisabledReasonEmailWorkflowEnabled,
  [LicenseItemDisableReason.EXTERNAL_TASKS_WORKFLOW_ENABLED]: TranslationKeys.SettingsFormDisabledReasonExternalTasksWorkflowEnabled,
  [LicenseItemDisableReason.INTERACT_FOR_SERVICE_IS_USED]: TranslationKeys.SettingsFormDisabledReasonInteractForServiceIsUsed,
  [LicenseItemDisableReason.PREVENT_LICENSE_BREACH]: TranslationKeys.SettingsFormDisabledReasonLicenseBreach,
  [LicenseItemDisableReason.NIMBUS_UNIFY_SERVICE_LICENSE_DISABLED_REASON]:
    TranslationKeys.SettingsFormDisabledReasonNimbusUnifyServiceLicenseDisabledReason,
  [LicenseItemDisableReason.COMPANION_ON_TENANT_IS_DISABLED]: TranslationKeys.SettingsFormDisabledReasonCompanionOnTenantIsDisabled,
  [LicenseItemDisableReason.DIRECT_CALL_RESOURCE_ACCOUNT_ASSIGNED]:
    TranslationKeys.SettingsFormDisabledReasonDirectCallResourceAccountAssigned,
};

export const LicenseAddonItemDisableReasonTranslationMapper: Record<LicenseAddonItemDisableReason, TranslationKeys> = {
  [LicenseAddonItemDisableReason.INTERACT_FOR_SERVICE_IS_USED]: TranslationKeys.SettingsFormDisabledReasonInteractForServiceIsUsed,
  [LicenseAddonItemDisableReason.ENTERPRISE_OR_CONTACT_CENTER_REQUIRED]:
    TranslationKeys.SettingsFormDisabledReasonEnterpriseOrContactCenterRequired,
  [LicenseAddonItemDisableReason.INTERACT_ON_TENANT_IS_DISABLED]: TranslationKeys.SettingsFormDisabledReasonInteractOnTenantIsDisabled,
  [LicenseAddonItemDisableReason.PREVENT_LICENSE_BREACH]: TranslationKeys.SettingsFormDisabledReasonLicenseBreach,
};

export const UserLicenseDisabledReasonTypeTranslationMapper: Record<UserLicenseDisabledReasonType, TranslationKeys> = {
  [UserLicenseDisabledReasonType.PREVENT_LICENSE_BREACH]: TranslationKeys.SettingsFormDisabledReasonLicenseBreach,
  [UserLicenseDisabledReasonType.VIRTUAL_USER_ON_TENANT_IS_DISABLED]:
    TranslationKeys.SettingsFormDisabledReasonVirtualUserOnTenantIsDisabled,
};

export enum LicenseType {
  Advanced = 'Advanced',
  Assistant = 'Assistant',
  AttendantConsole = 'AttendantConsole',
  AudioVideo = 'AudioVideo',
  Companion = 'Companion',
  ContactCenter = 'ContactCenter',
  DirectCallHandling = 'DirectCallHandling',
  Email = 'Email',
  Enterprise = 'Enterprise',
  ExternalTask = 'ExternalTask',
  InstantMessaging = 'InstantMessaging',
  WebInteract = 'WebInteract',
}

export function IsEnterpriseTeam(license: LicenseType): boolean {
  return license !== LicenseType.Advanced;
}

export enum LicenseAddonType {
  Interact = 'Interact',
}

export enum VirtualUserLicenseType {
  VirtualUser = 'VirtualUser',
}

export const LicenseAddonTypeMapper: Record<LicenseAddonType, TranslationKeys> = {
  Interact: TranslationKeys.AdminAddonsInteract,
};

export const VirtualUserLicenseTypeMapper: Record<VirtualUserLicenseType, TranslationKeys> = {
  VirtualUser: TranslationKeys.AdminLicensingVirtualUserPreview,
};

export const LicenseTypeTranslationMapper: Record<LicenseType, TranslationKeys> = {
  AttendantConsole: TranslationKeys.AdminLicensesAttendantConsole,
  ContactCenter: TranslationKeys.AdminLicensesContactCenter,
  WebInteract: TranslationKeys.AdminLicensesWebInteract,
  Advanced: TranslationKeys.AdminLicensesAdvanced,
  Enterprise: TranslationKeys.AdminLicensesEnterprise,
  Assistant: TranslationKeys.AdminLicensesAssistant,
  InstantMessaging: TranslationKeys.AdminLicensingInstantMessaging,
  ExternalTask: TranslationKeys.AdminLicensingExternalTask,
  Email: TranslationKeys.AdminLicensingEmail,
  AudioVideo: TranslationKeys.AdminLicensingAudioVideo,
  Companion: TranslationKeys.AdminLicensingCompanion,
  DirectCallHandling: TranslationKeys.AdminLicensingDirectCallHandling,
};

export interface ILicenseItem {
  isEnabled: boolean;
  isActive: boolean;
  licenseType: LicenseType;
  disabledReasons: LicenseItemDisableReason[];
  availableLicenses?: number;
}

export interface ILicenseAddonItem {
  isActive: boolean;
  isEnabled: boolean;
  licenseType: LicenseAddonType;
  disabledReasons: LicenseAddonItemDisableReason[];
  availableLicenses?: number;
}

export interface IVirtualUserLicenseItem {
  isActive: boolean;
  isEnabled: boolean;
  licenseType: VirtualUserLicenseType;
  disabledReasons: UserLicenseDisabledReasonType[];
  availableLicenses?: number;
}
